import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LogoutComponent } from './pages/logout/logout.component'
import { Error404Component } from './pages/error/404/error-404.component'
import { RedirectSsoComponent } from './pages/redirect-sso/redirect-sso.component'
import { ApplicationComponent } from './pages/application/application.component'

const routes: Routes = [
  { path: 'logout', component: LogoutComponent },
  {
    path: 'covid',
    loadChildren: () => import('./themes/covid/covid.module')
        .then( m => m.CovidModule )
  },
  {
    path: 'scan',
    loadChildren: () => import('./themes/scan/scan.module')
        .then( m => m.ScanModule )
  },
  {
    path: 'desktop',
    loadChildren: () => import('./themes/desktop/desktop.module')
        .then( m => m.DesktopModule )
  },
  {
    path: 'debug',
    loadChildren: () => import('./themes/debug/debug.module')
        .then( m => m.DebugModule )
  },
  { path: '404', component: Error404Component },
  { path: 'v1/redirect_sso', component: RedirectSsoComponent },
  { path: ':applicationId', component: ApplicationComponent},
  { path: '', component: ApplicationComponent, pathMatch: 'full' },
  { path: '**', component: ApplicationComponent }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
